export const Profile_EN = {
  profile: {
    tabs: {
      posts: "Feed",
      challenges: "Challenges",
      community: "Community",
      gathers: "Gathers",
      teams: "Teams",
      achievements: "Achievements",
      error: "An error occurred. Failed to fetch your data.",
      mobile: {
        noChallenges: "You haven't made any challenges yet.",
        createChallenge: "Create a challenge",
        nothingFound: "Nothing found related to",
      },
    },
    challenges: {
      badges: {
        all: "all",
        participatingIn: "participatingIn",
        createdBy: "createdBy",
        favorites: "favorites",
        private: "private",
        completed: "completed",
        drafts: "drafts",
      },
    },
    community: {
      heading: "community",
      tabs: {
        friends_singular: "friend",
        friends_plural: "friends",
        following_singular: "following",
        following_plural: "following",
        followers_singular: "follower",
        followers_plural: "followers",
        empty_string1: "does not have any", // {userName} does not have any {currentTab} yet.
        empty_string2: "yet", // {userName} does not have any {currentTab} yet.
        following_empty_string1: "does not have a", // {userName} does not have a {currentTab} yet.
        following_empty_string2: "yet", // {userName} does not have a {currentTab} yet.
      },
      search: {
        placeholder: "Search by nickname",
      },
    },
    friends: {
      title: "Friends",
      no_friends_msg: "No friends added",
    },
    edit: {
      title: "Edit profile",
      tabs: {
        Avatar: "Avatar",
        Information: "Information",
        Connections: "Connections",
        Themes: "Themes",
      },
      avatar: {
        edit_msg: "Edit avatar",
        upload_msg: "Upload an image or pick one of our pre-defined avatars.",
        upload_title: "My uploads",
      },
      connections: {
        title: "Connecting your account",
        // In between desc1 and desc2 is the brands name
        desc1: "Connect your",
        desc2:
          "account with third-parties to participate in challenges. You can revoke access to your data at any time. Passwords and payment details will never be shared.",
        no_connections: "No connections",
        // In between desc1 and desc2 is the brands name
        no_connections_desc1: "Unlock all",
        no_connections_desc2: "features by connecting your accounts",
      },
      themes: {
        choose_msg:
          "Customize your World of Gamers experience by selecting a partner theme.",
      },
    },
    toast: {
      edit: {
        success: "Profile updated.",
        failed: "Failed to update profile",
      },
    },
    actions: {
      add_friend: "Add friend",
      unfriend: "Unfriend",
      cancel_friend_request: "Cancel request",
      accept_friend_request: "Accept friend request",
      decline_friend_request: "Decline friend request",
      follow: "Follow",
      unfollow: "Unfollow",
    },
  },
};
